<template>
  <div
    class="w-dropdown"
    role="menu"
    :class="{'open': val}"
    @mouseenter="hover(true)"
    @mouseleave="hover(false)"
  >
    <div
      :class="[{'w--open': val}, triggerClass]"
      class="w-dropdown-toggle"
      tabindex="0"
      @click="toggle"
    >
      <slot name="trigger" />
    </div>

    <nav
      :class="[{'w--open': val}, dropdownClass]"
      class="w-dropdown-list"
    >
      <slot :close="close" />
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'Dropdown',
    props: {
      triggerClass: String,
      dropdownClass: String,
      openOnHover: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        val: false,
      };
    },
    methods: {
      hover (val) {
        if (this.openOnHover) this.toggle(val);
      },
      toggle (val) {
        if (val === true) this.open();
        else if (val === false) this.close();
        else this.toggle(!this.val);
      },
      open () {
        this.val = true;
      },
      close () {
        this.val = false;
      },
    },
  };
</script>

<style lang="scss">
  .w-dropdown {
    &.open {
      z-index: 1000;
    }

    .w-dropdown-toggle {
      outline: none;
    }
  }
</style>
